import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './ProgrammableLogicController.frontend.types'

@Injectable({ providedIn: 'root' })
export class ProgrammableLogicController_ds_connectors_getService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { connector_name?: string, connector_ids?: string[] }): Promise<{ list?: { name?: string, warehouseId?: number, type?: string, projectId?: number, orderClassId?: number, connector_id?: string }[], reasons?: string[] }> 
  {
    let $url = `${environment.backendUrl}api/ProgrammableLogicController/functions/ds_connectors_get`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

